export type PulymShoppingValueObject = {
    is_tomorrow: boolean
}

export namespace PulymShoppingValueObject {
    export function construct(o: any): PulymShoppingValueObject {
        return {
            is_tomorrow: Boolean(o.isActive),
        }
    }

    export const description: Record<keyof PulymShoppingValueObject, string> = {
        is_tomorrow: '노출활성화',
    }
}